import * as React from "react";

export const Switch = ({ title, isChecked, onChange }) => {
    return (
        <div className='activation-wrapper'>
            <p className='activation-title'>{title}</p>
            <i className="activation-desc-icon" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 2C5.584 2 2 5.584 2 10C2 14.416 5.584 18 10 18C14.416 18 18 14.416 18 10C18 5.584 14.416 2 10 2ZM10.8 15.3333H9.2V8.13333H10.8V15.3333ZM10.8 6.53333H9.2V4.93333H10.8V6.53333Z" fill="#717171" />
            </svg></i>
            <label className="toggle">
                <input type="checkbox" id="cardValid" name="cardValid" checked={isChecked}
                    onChange={onChange} />
                <span className="onoff-switch"></span>
            </label>
        </div>
    )
}